import React from 'react'
import { Select as AntSelect } from 'antd'

const Select = (props) => {
  return (
    <AntSelect
      {...props}
      allowClear={props.allowClear !== undefined ? props.allowClear : true}
      showSearch={props.showSearch !== undefined ? props.showSearch : true}
    />
  )
}

export default Select
